import styled from 'styled-components';
import colors from '../../styles/colors';

export const ModalContainer = styled.div`
	max-widht: 72.5rem;
	display: flex;
	flex-direction: column;
	align-items: center;
	background: #ffffff;
	padding: 2.5rem 1rem;

	svg {
		font-size: 2.5rem;
		color: ${colors.brandPrimary};
		margin-bottom: 0.75rem;
	}
`;

export const ParaContainer = styled.div`
	margin-top: 0.25rem;
	margin-bottom: 3.75rem;
`;
